import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import AuthorizationError from '../components/2compounds/AuthorizationError';
import DashboardReviewQueue from '../features/dashboard-v1/DashboardReviewQueue';
import { canViewDashboardApprovals } from '../features/dashboard-v1/dashboardPermissions';
import { HistoryCorrectionsPanel } from '../features/dynamictabs/HistoryCorrectionsQueue';
import { canViewHistoryApprovals } from '../features/dynamictabs/historyCorrections';
import { isAllowedToView, isAllowedToViewAdminAccess } from '../services/permissions/permissionHelper';
import DataRecordStatusTab from './dataImportApproval/DataRecordStatusTab';

export default function ApprovalsPage() {
  const queues = [
    canViewDashboardApprovals() && { id: 'dashboard', label: 'Dashboard data', Component: DashboardReviewQueue },
    (isAllowedToViewAdminAccess() || isAllowedToView('approvals')) && { id: 'imports', label: 'Data imports', Component: DataRecordStatusTab },
    canViewHistoryApprovals() && { id: 'history', label: 'Historical corrections', Component: HistoryCorrectionsPanel }
  ].filter(Boolean);
  const [selected, setSelected] = useState(queues[0]?.id);
  if (!queues.length) return <AuthorizationError />;
  const active = queues.find(q => q.id === selected) || queues[0];
  const Content = active.Component;
  return <Box data-testid="approvals-page" sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
    {queues.length > 1 && <Tabs aria-label="Approval queues" value={active.id} onChange={(_, id) => setSelected(id)}>
      {queues.map(q => <Tab key={q.id} id={`${q.id}-approvals-tab`} value={q.id} label={q.label} />)}
    </Tabs>}
    <Box role="tabpanel" aria-labelledby={queues.length > 1 ? `${active.id}-approvals-tab` : undefined} sx={{ flex: 1, minHeight: 0 }}><Content /></Box>
  </Box>;
}
